import { render, staticRenderFns } from "./UserAddressRow.vue?vue&type=template&id=24bbd6b8&"
import script from "./UserAddressRow.vue?vue&type=script&lang=js&"
export * from "./UserAddressRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports